import { render, staticRenderFns } from "./StorefrontReshipReportByMonth.vue?vue&type=template&id=991e880c"
import script from "./StorefrontReshipReportByMonth.vue?vue&type=script&lang=js"
export * from "./StorefrontReshipReportByMonth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../ClientApp/wwwroot/dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports